import { render } from "./message-system.vue?vue&type=template&id=4cbbc4fe&scoped=true&ts=true"
import script from "./message-system.vue?vue&type=script&lang=ts"
export * from "./message-system.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=4cbbc4fe&lang=scss&scoped=true"

import exportComponent from "D:\\phpstudy_pro\\WWW\\tengxunshipin\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbbc4fe"]])

export default __exports__